<script>
    //import Menu from "../../components/Menu.svelte";
    
    import { post } from "../../js/labit-connection";
    // import MenuMyProfile from "../../components/MenuMyProfile.svelte";
    import DetailCard from "../../components/DetailCard.svelte";
    import Picture from "../../components/Picture.svelte";
    import Combobox from "../../components/Combobox.svelte";
    import OwnItem from "../../components/OwnItemInvent.svelte";
    import Popup from "../../components/Popup.svelte";
    // import { getOutlookEmail } from "../../js/localInfo";
    
    //import { onMount } from "svelte";
    //import { each } from "svelte/internal";

    //let myRole = getRole(); 
    //let myId = getUserId();

    let qr = {id: "", tag: ""}, selectedQR = {label: "", value: ""}, selectedUser = {label: "", value: ""};
    let prop = "";
    let visual = "finders";
    let user = {id: "", email: "", picture: "", name: "", items: []}
    let itemProps = {};
    let validQR = true;
    let validMail = true;
    let acceptedAction = false;
    let qrs = [], users = [];
    let popupText = "", popupType = "";

    $: showPopup = showPopup;

    const modifyProperty = (event) => {
        prop = event.detail.prop;
        let key = prop.title;
        itemProps[key] = prop.props;
    }

    const clickedPopup = async (event) => {
        acceptedAction = event.detail.accepted;
        showPopup = false;
        
        if(acceptedAction) {
            await post( `update inventory set user_id=${user.id} where tag="${selectedQR.label}";` );
            createOwnItem();
            getUserItems(user.email);
        }
    }
    
    const ownDispatchedQR = async (event) => {
        selectedQR.label = event.detail.qr;

        const usuarioAsignado = await post(
            `select p.email, i.tag from people p inner join inventory i on p.contact_id = i.user_id where i.tag="${selectedQR.label}";`
        );
        
        showPopup = true;
        if(usuarioAsignado.length === 0) {
            popupText = "Wrong tag.";
            popupType = "alert";
        } else if(usuarioAsignado.length !== 0) {
            if(usuarioAsignado[0].name === user.email) {
                popupText = "This item actually belongs to you.";
                popupType = "alert";
            } else {
                popupText = `This item actually belongs to ${usuarioAsignado[0].name}. Are you sure?`;
                popupType = "prompt";
            }
        }
    }

    const findDispatchedQR = (event) => {
        selectedQR.label = event.detail.qr;
        getQR("find");
    }

    const createOwnItem = (categ = "", type = "", tag = "") => {
        user.items = [...user.items, {category: categ, type: type, tag: tag}];
        console.log(user.items);
    }

    const checkQRInput = (qr) => {
        if(qr.length == 8) {
            return true;
        } else {
            return false;
        }
    }
    
    const checkMailInput = (email) =>  {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    const getUserItems = async (email) => {
        const response = await post(
            `select p.contact_id as ID, p.name, p.picPath, i.category, i.type, i.tag from inventory i inner join people p on i.user_id = p.contact_id where p.email = "${email}";`
        );

        if (typeof response !== 'undefined' && response.length > 0) {
            user.name = response[0].name;
            user.picture = "https://test.labit.es/uploads" + response[0].picPath;
            user.id = response[0].ID;
            user.items = [];

            user.items = response.map((e) => {
                return({category: e.category, type: e.type, tag: e.tag});
            });

            console.log(user.items);
            createOwnItem();

            return true;
        } else {
            return false;
        }
    }

    const getQR = async (action = "") => {

        if(action === "find") {
            qr.tag = selectedQR.label;
        }

        validQR = checkQRInput(qr.tag);

        if (validQR) {
            const response = await post(
                `select i.id as qr_id, p.contact_id as user_id, p.picPath as Picture, p.Name as User, p.Email, Category, Type, Tag, Brand, Model, PN as 'Product Number', SN as 'Serial Number', prod_id_1 as 'ID 1', prod_id_2 as 'ID 2', Processor, 
                    graphic_card as 'Graphic Card', RAM, HDD, Size, Color, purchase_date as 'Purchase Date', Shop, Invoice, Status, warranty_time as 'Warranty Time', insurance_time as 'Insurance Time', Location
                from inventory i 
                inner join people p on 
                    i.user_id = p.contact_id
                where i.tag = "${qr.tag}";`
            );

            if (typeof response !== 'undefined' && response.length > 0) {
                
                user.picture = "https://test.labit.es/uploads" + response[0].Picture;
                user.name = response[0].User;
                user.email = response[0].Email;
                user.id = response[0].user_id;
                qr.id = response[0].qr_id;
                
                delete response[0].user_id;
                delete response[0].qr_id;
                delete response[0].Picture;
                delete response[0].User;
                delete response[0].Email;

                itemProps = response[0];
                
                changeVisual("gotQR");

            } else {
                validQR = false;
            }
        }
    };

    const getUser = async (action) => {

        if(action === "find"){
            user.email = selectedUser.value;
        }
        validMail = checkMailInput(user.email);

        if (validMail) {

            user.items = [];
            const gotItems = await getUserItems(user.email);

            if(user.items.length > 0 && gotItems) {
                changeVisual("gotUser");
            } else {
                validMail = false;
            }
        }
    };

    const onKeyPress = (e,func) => {
        if (e.charCode === 13) {
            if(func === "qr") {
                getQR();
            } else if (func === "email") {
                getUser();
            } else if (func === "userPic") {
                getPicture();
            }
        }
    };

    const getPicture = async () => {
        validMail = checkMailInput(user.email);
        if(validMail) {
            //userEmail = email;
            const newEmail = await post(
                `select picPath, contact_id AS ID from people where email = "${user.email}";`
            );
            if (typeof newEmail !== 'undefined' && newEmail.length > 0) {
                user.picture = "https://test.labit.es/uploads" + newEmail[0].picPath;
                user.id = newEmail[0].ID;
            } else {
                validMail = false;
                user.email = "?";
                user.picture = "/images/x-red.svg";
            }

        } else {
            validMail = false;
            user.email = "?";
            user.picture = "/images/x-red.svg";
        }
    };


    const saveChanges = async () => {

        let query = `UPDATE inventory set

            category='${itemProps.Category}',
            type='${itemProps.Type}',
            tag='${itemProps.Tag}',
            brand='${itemProps.Brand}',
            model='${itemProps.Model}',
            PN='${itemProps["Product Number"]}',
            SN='${itemProps["Serial Number"]}',
            prod_id_1='${itemProps["ID 1"]}',
            prod_id_2='${itemProps["ID 2"]}',
            processor='${itemProps.Processor}',
            graphic_card='${itemProps["Graphic Card"]}',
            ram='${itemProps.RAM}',
            hdd='${itemProps.HDD}',
            size='${itemProps.Size}',
            color='${itemProps.Color}',
            purchase_date='${itemProps["Purchase Date"]}',
            shop='${itemProps.Shop}',
            invoice='${itemProps.Invoice}',
            status='${itemProps.Status}',
            warranty_time='${itemProps["Warranty Time"]}',
            insurance_time='${itemProps["Insurance Time"]}',
            location='${itemProps.Location}',
            user_id='${user.id}'

            WHERE id='${qr.id}'`;

        const response = await post(
            query
        );
    };

    const getQrsAndUsers = async () => {
        let qrsQuery = 'select tag from inventory;';
        let usersQuery = 'select name, email from people where company_id = 2 and active = 1 and email like "%@labit.es" order by name;';

        qrs = await post( qrsQuery );
        users = await post( usersQuery );

        qrs = Object.entries(qrs).map((e) => { return {label: e[1].tag, value: e[0]} });
        users = Object.entries(users).map((e) => { return {label: e[1].name, value: e[1].email} });
    };

    const changeVisual = (type) => visual = type;
    const back = () => visual = "finders";

    //onMount(async () => {
    getQrsAndUsers();
    //});

</script>

<svelte:head>
    <title>SkyLab - Inventory</title>
</svelte:head>
<div class="dialogContent">

    {#if visual == "finders"}
            
        <div class="container">
            <div class="qr_finder">
                <img id="qr_image" src="/images/qr-code.svg" alt="qr code">
                <div class="wh-auto" on:keypress={(e) => onKeyPress(e, "qr")}>
                    {#if validQR}
                        <Combobox
                            options={qrs}
                            bind:selectedValue={selectedQR}
                            placeholder="QR code..."
                            width="100%"
                            persistentText=true
                        />
                    {:else}
                        <Combobox
                            options={qrs}
                            bind:selectedValue={selectedQR}
                            placeholder="QR code..."
                            width="100%"
                            persistentText=true
                            backgroundColor="#ff404063"
                        />
                    {/if}
                </div>
                <img class="find pointer" src="/images/loupe.svg" alt="" on:click={() => getQR("find")}>
            </div>

            <div class="user_finder">
                <img id="user_image" src="/images/user.svg" alt="user">
                <div class="wh-auto" on:keypress={(e) => onKeyPress(e, "email")}>
                    {#if validMail}
                        <Combobox
                            options={users}
                            bind:selectedValue={selectedUser}
                            placeholder="Email..."
                            width="100%"
                            persistentText=true
                        />
                    {:else}
                        <Combobox
                            options={users}
                            bind:selectedValue={selectedUser}
                            placeholder="Email..."
                            width="100%"
                            persistentText=true
                            backgroundColor="#ff404063"
                        />
                    {/if}
                </div>
                <img class="find pointer" src="/images/loupe.svg" alt="" on:click={() => getUser("find")}>
            </div>
        </div>
    
    {:else if visual == "gotQR"}

        <div class="qr_details">
            <div class="user_field">
                <img class="pointer" src="/images/arrow-left.svg" width="50px" on:click={back} alt="">
                <div class="user_pic pointer" on:click={getUser}>
                    <Picture image={user.picture}/> 
                </div>

                <input class="w-100 userInput {validMail ? "" : "error"}" type="text" name="user" id="user" bind:value={user.email} on:keypress={(e) => onKeyPress(e, "userPic")} on:blur={() => getPicture()}/>

                <img class="pointer save_btn" src="/images/save.svg" alt="save" on:click={saveChanges}>
                <img class="pointer trash_btn" src="/images/trash.svg" alt="trash" on:click={null}>
            </div>
            <div class="details">
                {#each Object.entries(itemProps) as [prop_key, prop_val] (prop_key) }
                    <DetailCard
                        title={prop_key}
                        props={prop_val}
                        on:modProp={modifyProperty}
                    />
                {/each}
            </div>
        </div>

    {:else if visual == "gotUser"}   

        <div class="user_details">
            <div class="user_field">
                <img class="pointer" src="/images/arrow-left.svg" width="50px" on:click={back} alt="">
                <div class="user_pic">
                    <Picture image={user.picture} />
                </div>
                <span>{user.name}</span>
            </div>
            <div class="details">
                {#if showPopup}
                    <div class="alertDiv">
                        <Popup
                            {popupType}
                            {popupText}
                            on:dispatchedClick={clickedPopup}
                        />
                    </div>
                {/if}
                {#each user.items as item (item)}
                    <OwnItem
                        qrList={qrs}
                        type={item.type || item.category}
                        tag={item.tag}
                        goToDetails={getQR}
                        on:dispatchedQR={findDispatchedQR}
                        on:dispatchedOwnQR={ownDispatchedQR}
                    />
                {/each}

                <OwnItem
                    qrList={qrs}
                    toAssign={true}
                    goToDetails={getQR}
                    on:dispatchedQR={findDispatchedQR}
                    on:dispatchedOwnQR={ownDispatchedQR}
                />
                <!--
                <div class="addItemContainer">
                    <img class="pointer icon" src="/images/plus.svg" alt="add new item" on:click={createOwnItem}/>
                </div>
                -->
            </div>
        </div>

    {/if}
</div>

<style>
    div.dialogContent{
        background-color: var(--labit-background-gray);
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        margin-top: 20px;
    }
    
    .container, .qr_details, .user_details {
        border-radius: 19px;
        width: 1640px;
        height: 87%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
    }
    .qr_details, .user_details {
        background-color: white;
        justify-content: space-around;
        flex-wrap: wrap;
        align-items: center;
        align-content: space-around;
    }

    .user_field {
        padding-top: 40px;
        display: flex;
        align-items: center;
        flex-direction: column;
        height: 100%;
        width: 20%;
    }

    .details {
        flex-direction: column;
        /* justify-content: space-between; */
        flex-wrap: wrap;
        align-content: center;
        height: 70%;
        width: 80%;
        display: flex;
    }

    .user_pic {
        margin-top: 40px;
        width: 144px;
        height: 144px;
    }
    .user_field span {
        margin-top: 10px;
    }

    div.qr_finder, div.user_finder {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 30%;
        background-color: white;
        height: 80%;
        border-radius: 19px;
    }

    #qr_image, #user_image {
        margin-bottom: 110px;
        width: 120px;
    }

    .wh-auto {
        width: auto;
        height: auto;
    }

    .find {
        width:48px;
        margin-top: 20px;
    }

    .pointer {
        cursor: pointer;
    }

    .save_btn {
        width: 40px;
        margin-top: 150px;
    }
    .trash_btn {
        width: 40px;
        margin-top: 20px;
    }

    .userInput {
        margin-top: 20px;
        text-align:center;
        background-color: white;
        border-style: solid;
        border-color: var(--labit-gray);
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 960px/960px;
        font-size: 12px;
        position: relative;
    }

    .error {
        background-color: #ff404063;
    }
	input[type="text"] {
		border: none;
		text-align: center;
	}
    .alertDiv {
        position: absolute;
        width: 350px;
        height: 200px;
        top: 40%;
        left: 41%;
        border-radius: 10px;
        background-color: #d7e1ea;
        z-index: 1;
        box-shadow: 2px 1px 3px 0px #afafaf;
    }
</style>